<ion-header>
    <ion-toolbar>
        <ion-title>Доступні принтери</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list [inset]="true" *ngIf="!selectedPrinter">
        <ion-item [button]="true" *ngFor="let p of printers; trackBy: trackPrinter" (click)="selectPrinter(p)">
            <ion-icon slot="start" [name]="getConnectionIcon(p.connectionType)"></ion-icon>
            <ion-label>
                <h2>{{ getDisplayName(p) }}</h2>
                <p>{{ getConnectionLabel(p.connectionType) }}</p>
            </ion-label>
            <ion-note slot="end">
                {{ getConnectionLabel(p.connectionType) }}
                <ng-container *ngIf="p.isConnected"> · online</ng-container>
            </ion-note>
        </ion-item>
        <ion-item *ngIf="!printers?.length" lines="none">
            <ion-label class="ion-text-center">
                <p>Принтерів не знайдено</p>
            </ion-label>
        </ion-item>
    </ion-list>
    <ion-card *ngIf="selectedPrinter">
        <ion-card-header>
            <ion-card-title>{{ getDisplayName(selectedPrinter) }}</ion-card-title>
            <ion-card-subtitle>
                <ion-icon [name]="getConnectionIcon(selectedPrinter.connectionType)"></ion-icon>
                {{ getConnectionLabel(selectedPrinter.connectionType) }}
            </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
            <ng-container *ngIf="canAddPrinter(selectedPrinter); else cannotAdd">
                Перевірте роботу принтера перед додаванням

                <div class="ion-padding" *ngIf="canTestPrint(selectedPrinter)">
                    <ion-button fill="outline" size="small" shape="round" (click)="testPrint()">
                        <ion-icon name="print-outline"></ion-icon>
                        Перевірити друк
                    </ion-button>
                </div>
            </ng-container>
            <ng-template #cannotAdd>
                Цей пристрій не можна додати. Для USB потрібен ідентифікатор пристрою, для Windows — черга принтера.
            </ng-template>
        </ion-card-content>



        <ion-grid class="p-0">
            <ion-row>
                <ion-col class="p-0">
                    <ion-button fill="clear" (click)="openList()">
                        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
                        Повернутися
                    </ion-button>
                </ion-col>

                <ion-col class="p-0" size="auto">
                    <ion-button
                        fill="solid"
                        shape="round"
                        (click)="addPrinter()"
                        [disabled]="!canAddPrinter(selectedPrinter)"
                    >Додати</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>

</ion-content>
<ion-footer *ngIf="!selectedPrinter">

    <ion-toolbar class="ion-text-end">

        <ion-button size="default" shape="round" fill="outline" (click)="close()">
            Закрити
        </ion-button>

    </ion-toolbar>
</ion-footer>
